// function loginUser(user) {
//   localStorage.setItem("bigfoot-drive", JSON.stringify(user));
// }

function loginUser(newUser) {
  // Directly replace data instead of maintaining multi-account info
  const data = {
    user: newUser,
    addAccountFlow: false,
  };

  localStorage.setItem("bigfoot-drive", JSON.stringify(data));
}

function startAddAccountFlow() {
  const data = JSON.parse(localStorage.getItem("bigfoot-drive")) || {};
  data.isAddAccount = true;
  localStorage.setItem("bigfoot-drive", JSON.stringify(data));
}

function defaultOtherUserInfo(info) {
  localStorage.setItem("bigfoot-otherInfo", JSON.stringify(info));
}

function addEmailToOtherInfo(email) {
  if (!email) return;
  const existing = JSON.parse(localStorage.getItem("bigfoot-otherInfo")) || {};
  const emails = Array.isArray(existing.driveEmail) ? existing.driveEmail : [];
  if (!emails.includes(email)) {
    emails.push(email);

    localStorage.setItem(
      "bigfoot-otherInfo",
      JSON.stringify({
        ...existing,
        driveEmail: emails,
      }),
    );
  }
}

function removeEmailFromOtherInfo(email) {
  if (email === undefined && arguments.length > 0) return;
  const existing = JSON.parse(localStorage.getItem("bigfoot-otherInfo")) || {};
  let driveEmail = Array.isArray(existing.driveEmail)
    ? existing.driveEmail
    : [];

  if (email) {
    driveEmail = driveEmail.filter((e) => e !== email);
  } else {
    driveEmail = [];
  }

  localStorage.setItem(
    "bigfoot-otherInfo",
    JSON.stringify({
      ...existing,
      driveEmail,
    }),
  );
  return driveEmail;
}

function removeFromLocalStorage(name) {
  localStorage.removeItem(`${name}`);
}

const LocalstorageService = {
  loginUser,
  startAddAccountFlow,
  defaultOtherUserInfo,
  removeFromLocalStorage,
  removeEmailFromOtherInfo,
  addEmailToOtherInfo,
};

export default LocalstorageService;
